import { createBrowserUser, User } from "@realestate.com.au/user";

// eslint-disable-next-line @typescript-eslint/ban-types
export const getUserData = (getUser: () => User) => (): {} => {
  const user = getUser();
  const data = user.isSignedIn
    ? {
        user_login_status: "logged_in",
        my_rea_id: user.consumerId,
        reauid: user.userId,
        locke_id: user.lockeId,
        country_code: user.countryCode,
      }
    : {
        user_login_status: "not_logged_in",
        reauid: user.userId,
        country_code: user.countryCode,
      };
  return {
    user: {
      schema: "iglu:au.com.realestate/user/jsonschema/2-0-9",
      data,
    },
  };
};

// eslint-disable-next-line @typescript-eslint/ban-types
const getUserDataWithBrowserSupport = (): (() => {}) =>
  getUserData(createBrowserUser);

export default getUserDataWithBrowserSupport;
